// extracted by mini-css-extract-plugin
export default {"LanguageSelector":"styles_LanguageSelector__PErOc","label":"styles_label__qPzoY"};